

export const BETSLIP_MULTIPLIER_COUNTS_DEFAULTS = ['+10', '+50', '+100', '+250', '+500'];
export const BETSLIP_COUPON_COUNT_DEFAULTS = ['+10', '+25', '+50'];
export const BETSLIP_DEFAULT_STAKE_QUICK_AMOUNTS = [50, 100, 500, 1000, 7500];
export const BETSLIP_MULTI_COUPON_VALUE_MAX_DEFAULTS = 500;
export const BETSLIP_BET_DELAY_TIME_DEFAULTS = 7;
export const BET_TIMEOUT_DURATION_DEFAULTS = 24;
export const BETSLIP_BET_DELAY_REQUEST_INTERVAL_DEFAULTS = 1;
